import uploadModal from './uploadModal.html';

/* @ngInject */
export default function (params) {
	let {
		    $scope,
		    LayoutService,
		    $stateParams,
		    toastr,
		    DataTablesService,
		    PermissionsCategories,
		    PermissionsGates,
		    PermissionsUsers,
		    PermissionsServiceUsers,
		    DocumentsDirectories,
		    DocumentsDocuments,
		    DocumentsVersions,
		    STATUSES,
		    $state,
		    moment,
		    $uibModal,
		    AuthService,
		    $timeout,
		    DocumentsService,
	    } = params;

	const parseFile = (file) => {
		let name      = file.name;
		let extension = '';

		const extensionSeparator = file.name.lastIndexOf('.');

		if (extensionSeparator !== -1) {
			name      = file.name.substring(0, extensionSeparator);
			extension = file.name.substring(extensionSeparator + 1);
		}

		return {
			name,
			extension,
			size:     file.size,
			mimeType: file.type,
		};
	};

	$scope.documentVersionId = null;

	$scope.documentVersion = null;

	$scope.documentVersionSelectVersion = (documentVersionId) => {
		$scope.documentVersionId = documentVersionId;

		let documentVersion = $scope.document.data.versions.find((version) => {
			return version.id === documentVersionId;
		});

		if (documentVersion) {
			documentVersion.downloadURL = DocumentsService.getDownloadURLForDocumentVersionId(documentVersionId);
		}

		$scope.documentVersion = documentVersion;
	};

	$scope.documentVersionDeselectVersion = () => {
		$scope.documentVersionId = null;

		$scope.documentVersion = null;
	};

	$scope.documentVersionUploadVersion = (documentId) => {
		$uibModal.open({
			animation:                  true,
			template:                   uploadModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.modalOriginalDocument = $scope.documentsById[documentId];

				$scope.modalDocumentVersion = {
					version: '',
				};

				$scope.modalFile = null;

				$scope.modalShowProgress     = false;
				$scope.modalProgress         = 0;
				$scope.modalProgressUploaded = 0;

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					if ($scope.modalFile) {
						const file = parseFile($scope.modalFile);

						const document = {
							name:        $scope.modalOriginalDocument.name,
							directory:   $scope.modalOriginalDocument.parent,
							version:     {
								version:   $scope.modalDocumentVersion.version,
								name:      file.name,
								extension: file.extension,
								fileSize:  file.size,
								mimeType:  file.mimeType,
							},
							permissions: null, // Will keep the existing permissions
						};

						DocumentsDocuments.one(documentId)
						                  .customPUT(document, null, {
							                  include: 'latestVersion.uploadForm',
						                  })
						                  .then((returnedDocument) => {
							                  const latestVersion = returnedDocument.latestVersion;
							                  const uploadForm    = latestVersion.uploadForm;

							                  $scope.modalProgress         = 0;
							                  $scope.modalProgressUploaded = 0;
							                  $scope.modalShowProgress     = true;

							                  return DocumentsDocuments.uploadToStorage(uploadForm, $scope.modalFile);
						                  })
						                  .then((storageResponse) => {
							                  $uibModalInstance.close();

							                  $scope.refreshDocument();
						                  }, (storageError) => {
							                  throw storageError;
						                  }, (storageProgressEvent) => {
							                  $scope.modalProgress         = parseInt(storageProgressEvent.loaded / storageProgressEvent.total * 100);
							                  $scope.modalProgressUploaded = storageProgressEvent.loaded;
						                  })
						                  .catch((error) => {
							                  toastr.clear();
							                  toastr.error('There was an error while uploading the document, please try again.', 'Error');

							                  $scope.modalShowProgress     = false;
							                  $scope.modalProgress         = 0;
							                  $scope.modalProgressUploaded = 0;
						                  });
					} else {
						toastr.clear();
						toastr.warning('You must select a file to upload.', 'Select File');
					}
				};
			},
		});
	};

	$scope.reviewDocumentVersion = (documentVersionId) => {
		let documentVersion = $scope.document.data.versions.find((version) => {
			return version.id === documentVersionId;
		});

		if (documentVersion) {
			DocumentsVersions.one(documentVersionId)
			                 .customPOST({}, 'reviews')
			                 .then(() => {
				                 toastr.clear();
				                 toastr.success('Successfully marked the material as reviewed.', 'Success');
			                 });
		}
	};
}


// WEBPACK FOOTER //
// ./src/js/endpoints/supportWorker/documents/root/controllers/documentVersion/index.js